/* eslint-disable */
import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { getBillableActivityById } from "helper/BillingHelper/BillingHelper";
import { API_BASE_URL } from "helper/UrlHelper"; // ✅ Importar API_BASE_URL

const BillableActivityDetail = ({ open, onClose, activity: propActivity, currentTab }) => {
  const { t } = useTranslation();
  const [activity, setActivity] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [showOdooJson, setShowOdooJson] = useState({});
  const [exportingStates, setExportingStates] = useState({}); // ✅ Estado para controlar loading por SO

  useEffect(() => {
  if (open && propActivity) {
    if (currentTab === 0) {
      setActivity(propActivity);
      console.log('🔍 DEBUG Activity Data:', propActivity); // ✅ AÑADE ESTO
      setLoading(false);
      setError(null);
    } else {
      fetchActivityDetails();
    }
  }
}, [open, propActivity, currentTab]);

  const fetchActivityDetails = async () => {
    try {
      setLoading(true);
      setError(null);
      
      const activityId = propActivity._id || propActivity.source_id;
      const response = await getBillableActivityById(activityId);
      
      if (response && (response.status || response.success)) {
        setActivity(response.data);
        console.log('🔍 DEBUG Activity Details:', response.data);
      } else {
        console.warn('No se pudo cargar detalle completo, usando datos básicos');
        setActivity(propActivity);
      }
    } catch (err) {
      console.warn('Error cargando detalles, usando datos básicos:', err);
      setActivity(propActivity);
    } finally {
      setLoading(false);
    }
  };

  const getStatusColor = (status) => {
    const colors = {
      PENDING: "warning",
      READY: "info",
      IN_ORDER: "primary",
      SO_CREATED: "primary",
      PARTIALLY_INVOICED: "secondary",
      FULLY_INVOICED: "success",
      PAID: "success",
      NON_BILLABLE: "secondary",
      CANCELLED: "danger",
      DELETED: "danger"
    };
    return colors[status] || "secondary";
  };

  const getActivityTypeColor = (type) => {
    const colors = {
      APPOINTMENT: "primary",
      MEDICAL_TEST: "info",
      DIAGNOSTIC_IMAGING: "secondary",
      IMMUNIZATION: "success",
      MEDICINE: "warning",
      PRODUCT: "secondary",
      SERVICE: "primary",
      PROCEDURE: "info",
      OTHER: "secondary"
    };
    return colors[type] || "secondary";
  };

  const formatDate = (date) => {
    if (!date) return "-";
    return new Date(date).toLocaleDateString();
  };

  const formatDateTime = (date) => {
    if (!date) return "-";
    return new Date(date).toLocaleString();
  };

  const formatCurrency = (amount) => {
    if (!amount && amount !== 0) return "-";
    return `€${Number(amount).toFixed(2)}`;
  };

  if (!open) return null;

  // ✅ Función MEJORADA para exportar a Odoo con preview + confirmación
  const handleExportToOdoo = async (salesOrderId, orderNumber) => {
    try {
      const token = localStorage.getItem('token');
      
      // ✅ PASO 1: Generar JSON Preview (sin enviar a Odoo)
      console.log('📋 Generando JSON preview...');
      setExportingStates(prev => ({ ...prev, [salesOrderId]: 'generating' }));
      
      const previewResponse = await fetch(
        `${API_BASE_URL}/billing/export-to-odoo?token=${token}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          },
          body: JSON.stringify({
            sales_order_ids: [salesOrderId],
            preview_only: true
          })
        }
      );

      const previewResult = await previewResponse.json();
      
      console.log('════════════════════════════════════════════════════════');
      console.log('📋 JSON PREVIEW GENERADO:');
      console.log(JSON.stringify(previewResult, null, 2));
      console.log('════════════════════════════════════════════════════════');
      
      setExportingStates(prev => ({ ...prev, [salesOrderId]: false }));
      
      // ✅ PASO 2: Mostrar JSON y confirmar
      const confirmSend = window.confirm(
        `✅ JSON generado correctamente.\n\n` +
        `Sales Order: ${orderNumber || salesOrderId}\n\n` +
        `¿Deseas ENVIAR este JSON a Odoo ahora?\n\n` +
        `(Puedes ver el JSON completo en la consola del navegador)`
      );
      
      if (!confirmSend) {
        console.log('⏸️ Usuario canceló el envío a Odoo');
        return;
      }
      
      // ✅ PASO 3: Enviar a Odoo
      console.log('🚀 Enviando a Odoo...');
      setExportingStates(prev => ({ ...prev, [salesOrderId]: 'exporting' }));
      
      const response = await fetch(
        `${API_BASE_URL}/billing/export-to-odoo?token=${token}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          },
          body: JSON.stringify({
            sales_order_ids: [salesOrderId]
          })
        }
      );

      const result = await response.json();
      
      console.log('════════════════════════════════════════════════════════');
      console.log('📋 RESPUESTA DE ODOO:');
      console.log(JSON.stringify(result, null, 2));
      console.log('════════════════════════════════════════════════════════');
      
      if (result.success) {
        alert(`✅ Sales Order exportado exitosamente a Odoo\n\nOdoo Order ID: ${result.data.exported[0]?.odoo_order_id}`);
        
        // ✅ Recargar detalles de la actividad
        await fetchActivityDetails();
      } else {
        throw new Error(result.message || 'Error al exportar');
      }
    } catch (error) {
      console.error('❌ Error exportando a Odoo:', error);
      alert(`❌ Error: ${error.message}`);
    } finally {
      setExportingStates(prev => ({ ...prev, [salesOrderId]: false }));
    }
  };

  // ✅ Función para descargar JSON
  const handleDownloadJson = (jsonData, salesOrderId) => {
    if (!jsonData) {
      alert('❌ No hay JSON disponible para descargar');
      return;
    }

    const jsonStr = JSON.stringify(jsonData, null, 2);
    const blob = new Blob([jsonStr], { type: 'application/json' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `sales_order_${salesOrderId}_${Date.now()}.json`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  };

  // ✅ Función para copiar JSON
  const handleCopyJson = async (jsonData) => {
    try {
      const jsonStr = JSON.stringify(jsonData, null, 2);
      await navigator.clipboard.writeText(jsonStr);
      alert('✅ JSON copiado al portapapeles');
    } catch (error) {
      console.error('Error copiando JSON:', error);
      alert('❌ Error al copiar JSON');
    }
  };

  return (
    <>
      {/* Backdrop */}
      <div 
        className="modal-backdrop fade show" 
        onClick={onClose}
        style={{ zIndex: 1040 }}
      ></div>

      {/* Drawer */}
      <div
        className="offcanvas offcanvas-end show"
        tabIndex="-1"
        style={{
          visibility: 'visible',
          width: '750px',
          maxWidth: '100%',
          zIndex: 1045,
          backgroundColor: '#f8f9fa'
        }}
      >
        {/* Header */}
        <div className="offcanvas-header bg-primary text-white" style={{ 
          background: 'linear-gradient(135deg, #0d6efd 0%, #0a58ca 100%)',
          padding: '1.5rem',
          boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
        }}>
          <div>
            <h5 className="offcanvas-title fw-bold mb-2">{t("Activity Details")}</h5>
            {activity && (
              <div className="d-flex gap-2">
                <span className={`badge bg-${getActivityTypeColor(activity.activity_type)} bg-opacity-25 border border-white text-white`}>
                  {t(activity.activity_type)}
                </span>
                <span className={`badge bg-${getStatusColor(activity.billing_status)} bg-opacity-25 border border-white text-white`}>
                  {t(activity.billing_status)}
                </span>
              </div>
            )}
          </div>
          <button
            type="button"
            className="btn-close btn-close-white"
            onClick={onClose}
            aria-label="Close"
          ></button>
        </div>

        {/* Body */}
        <div className="offcanvas-body" style={{ overflowY: 'auto', padding: '1.5rem' }}>
          {loading ? (
            <div className="text-center py-5">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          ) : error ? (
            <div className="alert alert-danger" role="alert">
              {error}
            </div>
          ) : activity ? (
            <>
              {/* Basic Info Card */}
              <div className="card shadow-sm mb-3 border-0">
                <div className="card-body p-4">
                  <h6 className="card-title text-primary fw-bold mb-3">
                    <i className="bi bi-info-circle me-2"></i>
                    {t("General Information")}
                  </h6>
                  
                  {activity.code && (
                    <div className="mb-3">
                      <label className="form-label text-muted text-uppercase fw-semibold small">{t("Code")}</label>
                      <p className="fw-medium mb-0">{activity.code}</p>
                    </div>
                  )}
                  
                  <div className="mb-3">
                    <label className="form-label text-muted text-uppercase fw-semibold small">{t("Description")}</label>
                    <p className="mb-0">{activity.description}</p>
                  </div>

                  {activity.internal_notes && (
                    <div className="alert alert-warning border-start border-4 border-warning mb-0">
                      <label className="form-label text-muted text-uppercase fw-semibold small mb-1">{t("Internal Notes")}</label>
                      <p className="mb-0 small">{activity.internal_notes}</p>
                    </div>
                  )}
                </div>
              </div>

              {/* Patient & Doctor Card */}
              <div className="card shadow-sm mb-3 border-0">
                <div className="card-body p-4">
                  <h6 className="card-title text-primary fw-bold mb-3">
                    <i className="bi bi-people me-2"></i>
                    {t("Patient & Healthcare Provider")}
                  </h6>
                  
                  <div className="row g-3">
                    <div className="col-md-6">
                      <div className="p-3 bg-light rounded border">
                        <label className="form-label text-muted text-uppercase fw-semibold small mb-2">{t("Patient")}</label>
                        <h6 className="fw-bold text-dark mb-2">
  {activity.patient_id?.name && activity.patient_id?.surname 
    ? `${activity.patient_id.name} ${activity.patient_id.surname}`
    : activity.patient_id?.name || 
      activity.patient_name || 
      "-"}
</h6>

{activity.patient_id?.email && (
  <p className="mb-1 small text-muted">
    <i className="bi bi-envelope me-1"></i>
    {activity.patient_id.email}
  </p>
)}

{activity.patient_id?.phone && (
  <p className="mb-1 small text-muted">
    <i className="bi bi-telephone me-1"></i>
    {activity.patient_id.phone}
  </p>
)}

{activity.patient_id?._id && (
  <span className="badge bg-primary mt-2">
    <i className="bi bi-card-text me-1"></i>
    ID: {activity.patient_id._id}
  </span>
)}

{activity.patient_id?.address && (
  <p className="mb-1 small text-muted mt-2">
    <i className="bi bi-geo-alt me-1"></i>
    {activity.patient_id.address}
    {activity.patient_id.city && `, ${activity.patient_id.city}`}
    {activity.patient_id.zipcode && ` (${activity.patient_id.zipcode})`}
  </p>
)}
                      </div>
                    </div>

                    {activity.doctor_name && (
                      <div className="col-md-6">
                        <div className="p-3 bg-light rounded border">
                          <label className="form-label text-muted text-uppercase fw-semibold small mb-2">{t("Doctor")}</label>
                          <h6 className="fw-bold text-dark">
                            <i className="bi bi-hospital me-2 text-primary"></i>
                            {activity.doctor_name}
                          </h6>
                        </div>
                      </div>
                    )}

                    {activity.company_id && (
                      <div className="col-12">
                        <div className="p-3 bg-light rounded border">
                          <label className="form-label text-muted text-uppercase fw-semibold small mb-2">{t("Medical Center / Company")}</label>
                          <p className="fw-semibold text-dark mb-0">
                            <i className="bi bi-building me-2 text-primary"></i>
                            {activity.company_id}
                          </p>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {/* Pricing Details Card */}
              <div className="card shadow-sm mb-3 border-0">
                <div className="card-body p-4">
                  <h6 className="card-title text-primary fw-bold mb-3">
                    <i className="bi bi-currency-euro me-2"></i>
                    {t("Pricing Details")}
                  </h6>
                  
                  <div className="p-4 bg-light rounded border">
                    {currentTab === 0 ? (
                      <>
                        <div className="mb-3">
                          <label className="form-label text-muted text-uppercase fw-semibold small">{t("Product Price")}</label>
                          <h2 className="text-success fw-bold mb-0">{formatCurrency(activity.product_price)}</h2>
                        </div>
                        
                        {activity.estimated_quantity && (
                          <div>
                            <label className="form-label text-muted text-uppercase fw-semibold small">{t("Estimated Quantity")}</label>
                            <h5 className="fw-semibold mb-0">{activity.estimated_quantity}</h5>
                          </div>
                        )}
                      </>
                    ) : (
                      <>
                        <div className="row g-3 mb-3">
                          <div className="col-6">
                            <label className="form-label text-muted text-uppercase fw-semibold small">{t("Unit Price")}</label>
                            <h5 className="text-primary fw-bold mb-0">{formatCurrency(activity.unit_price)}</h5>
                          </div>
                          
                          <div className="col-6">
                            <label className="form-label text-muted text-uppercase fw-semibold small">{t("Quantity")}</label>
                            <h5 className="fw-semibold mb-0">{activity.quantity}</h5>
                          </div>
                        </div>

                        <hr className="my-3" />

                        <div className="row g-3 mb-3">
                          <div className="col-6">
                            <label className="form-label text-muted small">{t("Subtotal")}</label>
                            <p className="h6 fw-semibold mb-0">{formatCurrency(activity.subtotal)}</p>
                          </div>

                          {activity.discount_amount > 0 && (
                            <div className="col-6">
                              <label className="form-label text-muted small">{t("Discount")}</label>
                              <p className="h6 fw-semibold text-danger mb-0">-{formatCurrency(activity.discount_amount)}</p>
                            </div>
                          )}

                          {activity.tax_amount > 0 && (
                            <div className="col-6">
                              <label className="form-label text-muted small">{t("Tax")} ({activity.tax_percentage}%)</label>
                              <p className="h6 fw-semibold mb-0">{formatCurrency(activity.tax_amount)}</p>
                            </div>
                          )}
                        </div>

                        <hr className="my-3 border-2" />

                        <div>
                          <label className="form-label text-muted text-uppercase fw-semibold small">{t("Total Amount")}</label>
                          <h2 className="text-success fw-bold mb-0">{formatCurrency(activity.total_amount)}</h2>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>

              {/* Splits Card */}
              {activity.split && activity.split.length > 0 && (
                <div className="card shadow-sm mb-3 border-0">
                  <div className="card-body p-4">
                    <h6 className="card-title text-primary fw-bold mb-3">{t("Payers Split")}</h6>
                    
                    <div className="list-group">
                      {activity.split.map((splitItem, index) => (
                        <div key={index} className="list-group-item border rounded mb-2">
                          <div className="d-flex justify-content-between align-items-center mb-1">
                            <h6 className="mb-0 fw-bold">
                              {splitItem.payer_snapshot?.display_name || splitItem.payer_snapshot?.name}
                            </h6>
                            <span className="badge bg-primary rounded-pill">{splitItem.percent}%</span>
                          </div>
                          <p className="mb-1 small text-muted">
                            {splitItem.payer_snapshot?.type_description} - {splitItem.payer_type}
                          </p>
                          {splitItem.max_amount && (
                            <p className="mb-0 small text-muted">
                              {t("Max Amount")}: <strong>{formatCurrency(splitItem.max_amount)}</strong>
                            </p>
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              )}

              {/* Dates Card */}
              <div className="card shadow-sm mb-3 border-0">
                <div className="card-body p-4">
                  <h6 className="card-title text-primary fw-bold mb-3">
                    <i className="bi bi-calendar-event me-2"></i>
                    {t("Important Dates")}
                  </h6>
                  
                  <div className="row g-3">
                    <div className="col-md-6">
                      <label className="form-label text-muted text-uppercase fw-semibold small">{t("Service Date")}</label>
                      <p className="fw-medium mb-0">{formatDate(activity.service_date)}</p>
                    </div>

                    <div className="col-md-6">
                      <label className="form-label text-muted text-uppercase fw-semibold small">{t("Performed At")}</label>
                      <p className="fw-medium mb-0">{formatDateTime(activity.performed_at)}</p>
                    </div>

                    <div className="col-md-6">
                      <label className="form-label text-muted text-uppercase fw-semibold small">{t("Created At")}</label>
                      <p className="mb-0">{formatDateTime(activity.createdAt)}</p>
                    </div>

                    {activity.updatedAt && (
                      <div className="col-md-6">
                        <label className="form-label text-muted text-uppercase fw-semibold small">{t("Last Updated")}</label>
                        <p className="mb-0">{formatDateTime(activity.updatedAt)}</p>
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {/* ❌ ELIMINADA: Sección "Billing Documents" (redundante) */}

              {/* Status History Card */}
              {activity.status_history && activity.status_history.length > 0 && (
                <div className="card shadow-sm mb-3 border-0">
                  <div className="card-body p-4">
                    <h6 className="card-title text-primary fw-bold mb-3">{t("Status History")}</h6>
                    
                    <div className="list-group">
                      {activity.status_history.map((history, index) => (
                        <div key={index} className="list-group-item border rounded mb-2">
                          <div className="d-flex justify-content-between align-items-start mb-1">
                            <p className="mb-0 small">
                              <span className="text-muted">{history.previous_status}</span> → <strong>{history.new_status}</strong>
                            </p>
                            <span className="badge bg-secondary">{formatDateTime(history.changed_at)}</span>
                          </div>
                          {history.reason && (
                            <p className="mb-0 small text-muted">{history.reason}</p>
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              )}

              {/* ✅ MEJORADA: Odoo Integration con JSON y botón de exportar */}
              {activity.so_links && activity.so_links.length > 0 && (
                <div className="card shadow-sm mb-3 border-0">
                  <div className="card-body p-4">
                    <h6 className="card-title text-primary fw-bold mb-3">
                      <i className="bi bi-cloud-arrow-up me-2"></i>
                      {t("Odoo Integration")}
                    </h6>

                    {activity.so_links.map((soLink, index) => {
                      const soDetails = activity.sales_orders_details?.find(
  so => so._id === soLink.sales_order_id || so.sales_order_id === soLink.sales_order_id
);

// ✅ DEBUG: Ver qué datos tenemos
console.log('🔍 Buscando SO details:', {
  soLink_id: soLink.sales_order_id,
  available_sales_orders: activity.sales_orders_details?.map(s => ({
    _id: s._id,
    sales_order_id: s.sales_order_id,
    order_number: s.order_number,
    has_json: !!s.odoo_json_preview
  }))
});

                      const isExported = soDetails?.odoo_order_id ? true : false;
const orderStatus = soDetails?.order_status || 'DRAFT';
const odooJson = soDetails?.odoo_json_preview;
const isExporting = exportingStates[soLink.sales_order_id];

// ✅ DEBUG
console.log('📋 SO Details encontrados:', {
  found: !!soDetails,
  order_number: soDetails?.order_number,
  has_json: !!odooJson,
  order_status: orderStatus,
  is_exported: isExported
});

                      return (
                        <div 
                          key={soLink.sales_order_id} 
                          className="mb-4 pb-3"
                          style={{ 
                            borderBottom: index < activity.so_links.length - 1 ? '1px solid #e0e0e0' : 'none' 
                          }}
                        >
                          {/* Header del SO */}
                          <div className="d-flex justify-content-between align-items-center mb-3">
                            <div>
                              <label className="form-label text-muted text-uppercase fw-semibold small mb-1">
                                {t("Sales Order")} #{index + 1}
                              </label>
                              <h6 className="mb-0 fw-bold">
                                {soDetails?.order_number || soLink.sales_order_id}
                              </h6>
                              <small className="text-muted">
                                {t("Amount")}: {formatCurrency(soLink.amount)} ({soLink.percent}%)
                              </small>
                            </div>
                            
                            <span className={`badge ${
                              orderStatus === 'EXPORTED' ? 'bg-success' :
                              orderStatus === 'DRAFT' ? 'bg-warning text-dark' :
                              'bg-secondary'
                            }`}>
                              {t(orderStatus)}
                            </span>
                          </div>

                          {/* SI YA FUE EXPORTADO */}
                          {isExported ? (
                            <div className="alert alert-success mb-0">
                              <div className="d-flex align-items-start gap-3">
                                <i className="bi bi-check-circle-fill text-success" style={{ fontSize: '24px' }}></i>
                                <div className="flex-grow-1">
                                  <strong>✅ {t("Exported to Odoo")}</strong>
                                  
                                  <div className="mt-2">
                                    <small className="text-muted d-block">{t("Odoo Order ID")}:</small>
                                    <code className="d-block bg-light p-2 rounded mt-1">
                                      {soDetails.odoo_order_id}
                                    </code>
                                  </div>

                                  {soDetails.odoo_exported_at && (
                                    <div className="mt-2">
                                      <small className="text-muted">
                                        <i className="bi bi-clock me-1"></i>
                                        {t("Exported")}: {formatDateTime(soDetails.odoo_exported_at)}
                                      </small>
                                    </div>
                                  )}

                                  {/* ✅ Botón para ver/ocultar JSON */}
                                  {odooJson && (
                                    <div className="mt-3">
                                      <button
                                        className="btn btn-sm btn-outline-secondary me-2"
                                        onClick={() => {
                                          const currentState = showOdooJson[soLink.sales_order_id] || false;
                                          setShowOdooJson({
                                            ...showOdooJson,
                                            [soLink.sales_order_id]: !currentState
                                          });
                                        }}
                                      >
                                        <i className="bi bi-code-square me-1"></i>
                                        {showOdooJson[soLink.sales_order_id] ? t('Hide JSON') : t('Show JSON')}
                                      </button>
                                      
                                      <button
                                        className="btn btn-sm btn-outline-primary me-2"
                                        onClick={() => handleDownloadJson(odooJson, soLink.sales_order_id)}
                                      >
                                        <i className="bi bi-download me-1"></i>
                                        {t('Download JSON')}
                                      </button>

                                      <button
                                        className="btn btn-sm btn-outline-secondary"
                                        onClick={() => handleCopyJson(odooJson)}
                                      >
                                        <i className="bi bi-clipboard me-1"></i>
                                        {t('Copy JSON')}
                                      </button>
                                      
                                      {showOdooJson[soLink.sales_order_id] && (
                                        <pre 
                                          className="bg-light p-3 rounded mt-2 border" 
                                          style={{ 
                                            maxHeight: '400px', 
                                            overflow: 'auto',
                                            fontSize: '11px'
                                          }}
                                        >
                                          {JSON.stringify(odooJson, null, 2)}
                                        </pre>
                                      )}
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          ) : (
                            /* SI NO FUE EXPORTADO (DRAFT) */
                            <div>
                              <div className="alert alert-warning mb-3">
                                <i className="bi bi-hourglass-split me-2"></i>
                                <strong>⏳ {t("Pending export to Odoo")}</strong>
                              </div>

                              {/* ✅ Mostrar JSON Preview si existe */}
                              {odooJson ? (
                                <div>
                                  <button
                                    className="btn btn-sm btn-outline-secondary mb-3 me-2"
                                    onClick={() => {
                                      const currentState = showOdooJson[soLink.sales_order_id] || false;
                                      setShowOdooJson({
                                        ...showOdooJson,
                                        [soLink.sales_order_id]: !currentState
                                      });
                                    }}
                                  >
                                    <i className="bi bi-code-square me-1"></i>
                                    {showOdooJson[soLink.sales_order_id] ? t('Hide JSON Preview') : t('Show JSON Preview')}
                                  </button>

                                  <button
                                    className="btn btn-sm btn-outline-primary mb-3 me-2"
                                    onClick={() => handleDownloadJson(odooJson, soLink.sales_order_id)}
                                  >
                                    <i className="bi bi-download me-1"></i>
                                    {t('Download JSON')}
                                  </button>

                                  <button
                                    className="btn btn-sm btn-outline-secondary mb-3"
                                    onClick={() => handleCopyJson(odooJson)}
                                  >
                                    <i className="bi bi-clipboard me-1"></i>
                                    {t('Copy JSON')}
                                  </button>

                                  {showOdooJson[soLink.sales_order_id] && (
                                    <pre 
                                      className="bg-light p-3 rounded mb-3 border"
style={{
maxHeight: '400px',
overflow: 'auto',
fontSize: '11px'
}}
>
{JSON.stringify(odooJson, null, 2)}
</pre>
)}
                              {/* ✅ Botón de exportar a Odoo */}
                              <div className="d-grid">
                                <button
                                  className="btn btn-primary"
                                  onClick={() => handleExportToOdoo(soLink.sales_order_id, soDetails?.order_number)}
                                  disabled={isExporting}
                                >
                                  {isExporting === 'generating' ? (
                                    <>
                                      <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                      {t('Generating JSON...')}
                                    </>
                                  ) : isExporting === 'exporting' ? (
                                    <>
                                      <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                      {t('Exporting to Odoo...')}
                                    </>
                                  ) : (
                                    <>
                                      <i className="bi bi-cloud-upload me-2"></i>
                                      🚀 {t("Export to Odoo")}
                                    </>
                                  )}
                                </button>
                              </div>
                            </div>
                          ) : (
                            <div className="alert alert-info">
                              <i className="bi bi-info-circle me-2"></i>
                              <em>{t("JSON preview not generated yet")}</em>
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          )}
        </>
      ) : null}
    </div>

    {/* Footer */}
    <div className="offcanvas-footer border-top bg-white p-3">
      <div className="d-flex justify-content-end">
        <button
          type="button"
          className="btn btn-secondary px-4"
          onClick={onClose}
        >
          {t("Close")}
        </button>
      </div>
    </div>
  </div>
</>
);
};
export default BillableActivityDetail;